export default __webpack_public_path__ + "static/media/Steering_Behaviour.f0e65fdd.avif";